import { createSlice} from '@reduxjs/toolkit'


// #TODO: Save to localstorage
const checkoutSectionSlice = createSlice({
    name: 'checkoutSection',
    initialState: {
        section: 'cart',
        error: '',
        clientSecret: ''
    },
    reducers: {
        updateCheckoutSection: (state, action) => {
            state.section = action.payload
        },
        updateCheckoutError: (state, action) => {
            state.error = action.payload
        },
        setClientSecret: (state, action) => {
            state.clientSecret = action.payload
        }

    }
})

export const {updateCheckoutSection, updateCheckoutError, setClientSecret} = checkoutSectionSlice.actions

export default checkoutSectionSlice